import React from 'react';

const ValueSection = () => {
  const values = [
    {
      title: "Financial Freedom",
      description: "follow your money and improve your net worth with the CashCanvas income, accounts, Budget, Investment, Savings and debt management all in one integrated features.",
      highlight: "improve your net worth"
    },
    {
      title: "Customized insights",
      description: "use our CashBot AI tool to find out exactly what you want to know about your finances. Save more and plan smarter with AI-driven insights.",
      highlight: "CashBot AI tool"
    },
    {
      title: "Plan together",
      description: "a household that plans together stays together. Use our Shared canvas feature to manage household finances with your partner and kids while keeping personal finances separate with Private Canvas.",
      highlight: "Shared canvas"
    },
    {
      title: "Absolute Data Control",
      description: "Secure, compliant data protection for all users. Forget unreliable auto-sync, import/export your data securely anytime, guaranteeing accurate data, the reliable foundation for your AI analysis.",
      highlight: "Forget unreliable auto-sync"
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-white to-[#f5f6fa]">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-4 text-[#0a363c] tracking-tight">
          Unlock a new level of personal finance management
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-[#e2bf9c]/20"
            >
              <h3 className="text-xl font-bold text-[#0a363c] mb-3 flex items-center gap-2">
                <span className="text-[#e2bf9c] text-2xl">•</span>
                {value.title}
              </h3>
              <p className="text-[#0a363c]/80 leading-relaxed">
                {value.description.split(value.highlight).map((part, i, arr) => (
                  <React.Fragment key={i}>
                    {part}
                    {i < arr.length - 1 && (
                      <span className="font-semibold text-[#0a363c]">
                        {value.highlight}
                      </span>
                    )}
                  </React.Fragment>
                ))}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueSection;